export default [
  {
    id: 4,
    active: true,
    confirm: 1,
    campaign_id: 4,
    campaign_name: "کمپین بنری روز مرد ۱۴۰۰",
    type: "بنری",
    created_at: "1400/11/23 10:10:51",
    updated_at: "1400/11/23 10:10:51",
    link: "https://rullplug-yaser.ir/landing-page-rullplug-yaser-parvanei",
    banners:[
      {
        size:"120-600",
        file:"/assets/img/banners/asttools/asttools-120-600.gif"
      },
      {
        size:"180-600",
        file:"/assets/img/banners/asttools/asttools-180-600.gif"
      },
      {
        size:"300-250",
        file:"/assets/img/banners/asttools/asttools-300-250.gif"
      },
      {
        size:"300-600",
        file:"/assets/img/banners/asttools/asttools-300-600.gif"
      },
      {
        size:"720-300",
        file:"/assets/img/banners/asttools/asttools-720-300.gif"
      },
      {
        size:"970-90",
        file:"/assets/img/banners/asttools/asttools-970-90.gif"
      },
      {
        size:"970-250",
        file:"/assets/img/banners/asttools/asttools-970-250.gif"
      }
    ]
  },
  {
    id: 3,
    active: true,
    confirm: 1,
    campaign_id: 3,
    campaign_name: "کمپین بنری روز زن ۱۴۰۰",
    type: "بنری",
    created_at: "1400/10/30 16:40:28",
    updated_at: "1400/10/30 16:40:28",
    link: "https://monirlock.ir/popular-products",
    banners:[
      {
        size:"120-600",
        file:"/assets/img/banners/aras/aras-120-600.gif"
      },
      {
        size:"180-600",
        file:"/assets/img/banners/aras/aras-180-600.gif"
      },
      {
        size:"300-250",
        file:"/assets/img/banners/aras/aras-300-250.gif"
      },
      {
        size:"300-600",
        file:"/assets/img/banners/aras/aras-300-600.gif"
      },
      {
        size:"720-300",
        file:"/assets/img/banners/aras/aras-720-300.gif"
      },
      {
        size:"970-90",
        file:"/assets/img/banners/aras/aras-970-90.gif"
      },
      {
        size:"970-250",
        file:"/assets/img/banners/aras/aras-970-250.gif"
      }
    ]
  },
  {
    id: 2,
    active: true,
    confirm: 1,
    campaign_id: 2,
    campaign_name: "کمپین بنری عید فطر ۱۴۰۰",
    type: "بنری",
    created_at: "1400/06/20 21:55:40",
    updated_at: "1400/06/20 21:55:40",
    link: "https://senfnews.com",
    banners:[
      {
        size:"120-600",
        file:"/assets/img/banners/monir/monir-120-600.gif"
      },
      {
        size:"180-600",
        file:"/assets/img/banners/monir/monir-180-600.gif"
      },
      {
        size:"300-250",
        file:"/assets/img/banners/monir/monir-300-250.gif"
      },
      {
        size:"300-600",
        file:"/assets/img/banners/monir/monir-300-600.gif"
      },
      {
        size:"720-300",
        file:"/assets/img/banners/monir/monir-720-300.gif"
      },
      {
        size:"970-90",
        file:"/assets/img/banners/monir/monir-970-90.gif"
      },
      {
        size:"970-250",
        file:"/assets/img/banners/monir/monir-970-250.gif"
      }
    ]
  },
  {
    id: 1,
    active: true,
    confirm: 1,
    campaign_id: 1,
    campaign_name: "کمپین بنری عید نوروز ۱۴۰۰",
    type: "بنری",
    created_at: "1399/12/27 11:00:30",
    updated_at: "1399/12/27 11:00:30",
    link: "https://senfnews.com",
    banners:[
      {
        size:"120-600",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-120-600.gif"
      },
      {
        size:"180-600",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-180-600.gif"
      },
      {
        size:"300-250",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-300-250.gif"
      },
      {
        size:"300-600",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-300-600.gif"
      },
      {
        size:"720-300",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-720-300.gif"
      },
      {
        size:"970-90",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-970-90.gif"
      },
      {
        size:"970-250",
        file:"/assets/img/banners/rullplug-yaser/rullplug-yaser-970-250.gif"
      }
    ]
  },
];
